<div id="error-404" class="d-flex justify-content-center">
  <div class="content d-flex justify-content-center flex-column align-items-center">
    <img class="logo" src="assets/icons/logo.png" alt="">
    <div class="error-code">404</div>
    <div class="message">{{'layout.pages.error.not_found' | transloco }}</div>
    <a class="back-link" [routerLink]="'/'">{{'layout.pages.error.back_to_home' | transloco }}</a>
  </div>
</div>